import { Anchor, Box, Group, Stack } from '@mantine/core';
import EmailInvite from '@projectMembers/components/EmailInvite/EmailInvite';
import ProjectMembersList from '@projectMembers/components/ProjectMembersList/ProjectMembersList';
import Text from '@ui/components/Text/Text';
import Project from 'src/entities/project';

const LEARN_MORE_MEMBERS_URL = 'https://support.verybusy.io/en/articles/5324033-how-to-add-a-member-to-your-workspace';

type MembersSectionProps = {
	project: Project;
	currentUserID: number;
	totalCount: number;
	addGroupModalStackOrder: number;
};

const MembersSection = ( { project, currentUserID, totalCount, addGroupModalStackOrder }: MembersSectionProps ) => (
	<Stack
		bg="var(--color-bg-container)"
		px={16}
		pt={12}
		pb={8}
		spacing={12}
		style={{ borderBottomRightRadius: 4, borderBottomLeftRadius: 4 }}
	>
		<EmailInvite project={project} addGroupModalStackOrder={addGroupModalStackOrder} />

		<Group position="apart" align="center" mt={12}>
			<Group spacing={4}>
				<Text variant="caption-regular" color="var(--color-text-primary)">Who have access</Text>
				{totalCount > 0 && (
					<Text variant="caption-regular" color="var(--color-text-secondary)">
						({totalCount} {totalCount === 1 ? 'Person' : 'People'})
					</Text>
				)}
			</Group>
			<Anchor
				href={LEARN_MORE_MEMBERS_URL}
				target="_blank"
				style={{ textDecoration: 'underline', color: 'var(--color-text-link)' }}
			>
				<Text variant="caption-regular" color="var(--color-text-link)">Learn More</Text>
			</Anchor>
		</Group>

		<Box style={{ maxHeight: 210, overflowY: 'auto' }}>
			<ProjectMembersList
				project={project}
				currentUserRole={project.currentUserRole}
				currentUserID={currentUserID}
			/>
		</Box>
	</Stack>
);

export default MembersSection;
